// src/contexts/SharedDataContext.tsx
import React, { createContext, useContext, useState } from 'react';
import { FilterOptions } from '../types/filters';

export interface ImportSuccessState {
  isSuccessful: boolean;
  createdCount: number;
  updatedCount: number;
}

export const INITIAL_IMPORT_SUCCESS: ImportSuccessState = {
  isSuccessful: false,
  createdCount: 0,
  updatedCount: 0,
};

interface SharedDataContextType {
  supporterData: unknown;
  setSupporterData: React.Dispatch<React.SetStateAction<unknown>>;
  effortData: unknown;
  setEffortData: React.Dispatch<React.SetStateAction<unknown>>;
  isBulkActionsConfirm: boolean;
  setIsBulkActionsConfirm: React.Dispatch<React.SetStateAction<boolean>>;
  // emailStats: any;
  // setEmailStats: React.Dispatch<React.SetStateAction<any>>;
  // selectedEffort: any;
  // setSelectedEffort: React.Dispatch<React.SetStateAction<any>>;
  allSelectedFilters: FilterOptions;
  setAllSelectedFilters: React.Dispatch<React.SetStateAction<FilterOptions>>;
  importSuccess: ImportSuccessState;
  setImportSuccess: React.Dispatch<React.SetStateAction<ImportSuccessState>>;
}

const SharedDataContext = createContext<SharedDataContextType | null>(null);

export const SharedDataProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [supporterData, setSupporterData] = useState<unknown>(null);
  const [effortData, setEffortData] = useState<unknown>(null);
  const [isBulkActionsConfirm, setIsBulkActionsConfirm] = useState<boolean>(false);
  const [allSelectedFilters, setAllSelectedFilters] = useState<FilterOptions>({});
  const [importSuccess, setImportSuccess] = useState<ImportSuccessState>(INITIAL_IMPORT_SUCCESS);

  // const [emailStats, setEmailStats] = useState<unknown>(null);
  // const [selectedEffort, setSelectedEffort] = useState<unknown>(null);

  return (
    <SharedDataContext.Provider
      value={{
        supporterData,
        setSupporterData,
        effortData,
        setEffortData,
        isBulkActionsConfirm,
        setIsBulkActionsConfirm,
        allSelectedFilters,
        setAllSelectedFilters,
        importSuccess,
        setImportSuccess,
        // emailStats,
        // setEmailStats,
        // selectedEffort,
        // setSelectedEffort,
      }}
    >
      {children}
    </SharedDataContext.Provider>
  );
};

export const useSharedData = () => {
  const context = useContext(SharedDataContext);
  if (!context)
    throw new Error('useSharedData must be used within SharedDataProvider');
  return context;
};
